// export const START_DATE = new Date(2021, 12, 31, 17, 30);
// export const END_DATE = new Date(2022, 1, 1, 2);
// export const FIRS_LOADED_PAGE = "appetizers";
// export const IS_SPECIALS_BUTTON_ACTIVE = false;
// export const SERVER_URL = "http://localhost:3000/";
export const SERVER_URL = "https://onami-menu.herokuapp.com/";

export const TIMEOUT_SEC = 15;

export const ADMIN_PASS = "2707";
